import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Search = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="search icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 17C2 8.71573 8.71573 2 17 2C25.2843 2 32 8.71573 32 17C32 25.2843 25.2843 32 17 32C8.71573 32 2 25.2843 2 17ZM17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34C21.2291 34 25.0974 32.4558 28.072 29.9004L30.3894 32.2178L29.7179 32.8894C28.9368 33.6704 28.9368 34.9368 29.7179 35.7178L41.3892 47.3892C42.1703 48.1702 43.4366 48.1702 44.2177 47.3892L47.0461 44.5607C47.8271 43.7797 47.8271 42.5134 47.0461 41.7323L35.3747 30.0609C34.5937 29.2799 33.3273 29.2799 32.5463 30.0609L31.8036 30.8036L29.5105 28.5105C32.2978 25.4825 34 21.44 34 17C34 7.61116 26.3888 0 17 0ZM33.9605 31.4752L31.1321 34.3036L42.8034 45.9749L45.6319 43.1465L33.9605 31.4752Z"
    />
  </svg>
)
